<template>
  <div class="title ljb-big-title flex ljb-double_center">
    {{ moduleTitle.title }}
    <span v-show="moduleTitle.text" class="text">
      {{ moduleTitle.text }}
      <!-- <van-icon name="arrow" /> -->
    </span>
  </div>
</template>
<script>
export default {
  name: 'ModuleTitle',
  props: {
    moduleTitle: {
      type: Object,
      default: function () {
        return ''
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .title{
    margin-top: $margin;
    // padding:  $padding;
    .text{
      margin-left: 10px;
      font-size: 14px;
      color: #B98727;
    }
    .arrow {
      margin-left: auto;
      width: 7px;
      height: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/title/ModuleTitleDhzx.vue